export const EFFICIENCY_SORT_STORAGE_KEY = 'callcenter::employeeEfficiencySort';

// Сортировка таблицы «Эффективность операторов» должна пережить уход в другой раздел: App
// рендерит только активный раздел, и состояние EmployeeAnalytics при каждом переключении
// теряется. В localStorage выбор переживает и перезагрузку. При выходе не чистится — как и
// свёрнутость сайдбара, это удобство браузера, а не данные учётной записи.
//
// Здесь только форма записи. Есть ли такой столбец в текущей таблице, решает
// resolveEfficiencySort: этап воронки мог уйти вместе со сменой пакета узлов.
export const readEfficiencySort = () => {
  try {
    const raw = localStorage.getItem(EFFICIENCY_SORT_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    const valid =
      typeof parsed?.key === 'string' &&
      parsed.key.length > 0 &&
      (parsed.direction === 'asc' || parsed.direction === 'desc');

    return valid ? { key: parsed.key, direction: parsed.direction } : null;
  } catch {
    return null;
  }
};

export const persistEfficiencySort = (sort) => {
  try {
    if (sort?.key) {
      localStorage.setItem(
        EFFICIENCY_SORT_STORAGE_KEY,
        JSON.stringify({ key: sort.key, direction: sort.direction })
      );
    } else {
      localStorage.removeItem(EFFICIENCY_SORT_STORAGE_KEY);
    }
  } catch {
    // no-op for environments without localStorage access
  }
};
